export const painPoints: string[] = [
  'Te despertás liviana y a media mañana ya parecés de tres meses de embarazo.',
  'Elegís la ropa según cuánto te va a apretar la panza ese día.',
  'Los gases, los ruidos y la urgencia te condicionan reuniones y salidas.',
  'Te dijeron “es colon irritable, comé tranquila”, y nadie te explicó qué hacer.',
  'Gastaste en dietas, probióticos y consultas que solo te dieron alivio parcial.',
]

export const costs: string[] = [
  'Otro año midiendo tu día según cuánto te hinchás',
  'Comidas afuera que terminan siempre igual: incomodidad y culpa',
  'Consultas que cierran con “hacé dieta y volvé en tres meses”',
  'Cansancio, niebla mental y humor que todos minimizan',
  'Otro año sin mapa, sin fases y sin dirección',
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Necesito el test de aliento para empezar?',
    answer:
      'No. El sistema funciona igual si todavía no tenés diagnóstico: es material educativo e informativo que complementa el tratamiento indicado por tu equipo médico, no lo reemplaza. Si ya tenés el test, el Volumen 1 te ayuda a interpretarlo.',
  },
  {
    question: '¿Los ingredientes son caros o difíciles de conseguir?',
    answer:
      'No. El protocolo prioriza alimentos y suplementos que se consiguen en supermercados, verdulerías y dietéticas argentinas.',
  },
  {
    question: '¿Cuándo veo resultados?',
    answer:
      'El intestino responde rápido. La mayoría nota menos distensión y menos gases entre los días 10 y 21 de aplicación constante, y los cambios de energía llegan poco después.',
  },
  {
    question: '¿Sirve si ya hice dieta baja en FODMAP y recaí?',
    answer:
      'Sí. La recaída casi siempre pasa por saltear la fase de motilidad y reparación. El Volumen 5 está dedicado exactamente a eso.',
  },
  {
    question: '¿La garantía es real?',
    answer:
      'Sí. Si en 30 días no es lo que esperabas, escribís a soportebiomalivido@gmail.com y te devolvemos el 100%. Sin preguntas.',
  },
  {
    question: '¿Es 100% digital?',
    answer:
      'Sí. Acceso inmediato en PDF. Podés leerlo desde el celular, la tablet o la computadora, e imprimirlo si preferís.',
  },
]

export const stats: Array<[string, string]> = [
  ['+240', 'personas aplicando el protocolo'],
  ['300+', 'páginas paso a paso'],
  ['5', 'bonos incluidos'],
  ['4.9/5', 'calificación'],
]
